import * as React from 'react';
import * as _ from 'lodash';
import { ITransformRow } from '../../../../../models/ITransform';
import { transformsStore } from '../../../../../mobx/transforms.store';
import { Environment } from '../../../../../const/environment';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import * as actions from '../../../../../redux/projects/actions.projects';
import store from '../../../../../store';
import projectHelper from '../../../../../services/ProjectHelper';

type FillTransformResultButtonProps = {
    row: ITransformRow,
    environment: Environment;
    onFinish: () => void;
    isVisibleAlways?: boolean;
    top?: number
    left?: number
    borderRadius?: number
    index: number
    className?: string
};

export function FillTransformResultButton({
    index,
    row,
    top = 0,
    left = 15,
    className,
    borderRadius,
    isVisibleAlways,
    onFinish,
    environment
}: FillTransformResultButtonProps) {
    const generateResultCb = async () => {
        try {
            const project = store.getState().projectsInfo.currentProject;
            const unsavedFiles = await projectHelper.getFilesWithUnsavedChanges(project);
            const isChangesShouldBeSaved = transformsStore.isChangesNeedToBeSavedBeforeGeneratingResult(row, index, unsavedFiles);

            if (isChangesShouldBeSaved) {
                const updateScrips = (param) => asyncDispatch(actions.updateScripts, store.dispatch, param);

                await updateScrips({
                    project,
                    environment,
                });
            }
            transformsStore.generateResult(row, index, onFinish);
        } catch (error) {
            console.log('Error:', error);
        }
    };
    const stopGenerationCb = () => {
        transformsStore.stopResultGeneration(row.id);
        onFinish();
    };

    const styles = {
        top: `${top}px`,
        left: `${left}px`,
        borderRadius: `${borderRadius}px`,
    };

    if (borderRadius !== undefined) {
        styles.borderRadius = `${borderRadius}px`;
    }

    return <div
        title={`${row.isResultLoading ? 'Pause result generation' : 'Generate result'}`}
        className={`fill-transform-result-btn ${row.isResultLoading && 'generation-in-process'} ${isVisibleAlways && 'visible-always'} ${className}`}
        onClick={row.isResultLoading ? stopGenerationCb : generateResultCb} style={styles}>
        {row.isResultLoading ?
            <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                width="800px" height="800px" viewBox="0 0 277.338 277.338">
                <g>
                    <path d="M14.22,45.665v186.013c0,25.223,16.711,45.66,37.327,45.66c20.618,0,37.339-20.438,37.339-45.66V45.665
               c0-25.211-16.721-45.657-37.339-45.657C30.931,0,14.22,20.454,14.22,45.665z"/>
                    <path d="M225.78,0c-20.614,0-37.325,20.446-37.325,45.657V231.67c0,25.223,16.711,45.652,37.325,45.652s37.338-20.43,37.338-45.652
               V45.665C263.109,20.454,246.394,0,225.78,0z"/>
                </g>
            </svg> :
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.5 2C5.5 1.44772 5.05228 1 4.5 1C3.94772 1 3.5 1.44772 3.5 2V3.5H2C1.44772 3.5 1 3.94772 1 4.5C1 5.05228 1.44772 5.5 2 5.5H3.5V7C3.5 7.55228 3.94772 8 4.5 8C5.05228 8 5.5 7.55228 5.5 7V5.5H7C7.55228 5.5 8 5.05228 8 4.5C8 3.94772 7.55228 3.5 7 3.5H5.5V2Z" fill="black" />
                <path d="M5.5 17C5.5 16.4477 5.05228 16 4.5 16C3.94772 16 3.5 16.4477 3.5 17V18.5H2C1.44772 18.5 1 18.9477 1 19.5C1 20.0523 1.44772 20.5 2 20.5H3.5V22C3.5 22.5523 3.94772 23 4.5 23C5.05228 23 5.5 22.5523 5.5 22V20.5H7C7.55228 20.5 8 20.0523 8 19.5C8 18.9477 7.55228 18.5 7 18.5H5.5V17Z" fill="black" />
                <path d="M13.9333 2.64102C13.7848 2.25483 13.4138 2 13 2C12.5862 2 12.2152 2.25483 12.0667 2.64102L10.3325 7.14988C10.0321 7.93093 9.93768 8.156 9.80855 8.33759C9.67899 8.5198 9.5198 8.67899 9.33759 8.80855C9.156 8.93768 8.93093 9.03207 8.14988 9.33248L3.64102 11.0667C3.25483 11.2152 3 11.5862 3 12C3 12.4138 3.25483 12.7848 3.64102 12.9333L8.14988 14.6675C8.93093 14.9679 9.156 15.0623 9.33759 15.1914C9.5198 15.321 9.67899 15.4802 9.80855 15.6624C9.93768 15.844 10.0321 16.0691 10.3325 16.8501L12.0667 21.359C12.2152 21.7452 12.5862 22 13 22C13.4138 22 13.7848 21.7452 13.9333 21.359L15.6675 16.8501C15.9679 16.0691 16.0623 15.844 16.1914 15.6624C16.321 15.4802 16.4802 15.321 16.6624 15.1914C16.844 15.0623 17.0691 14.9679 17.8501 14.6675L22.359 12.9333C22.7452 12.7848 23 12.4138 23 12C23 11.5862 22.7452 11.2152 22.359 11.0667L17.8501 9.33248C17.0691 9.03207 16.844 8.93768 16.6624 8.80855C16.4802 8.67899 16.321 8.5198 16.1914 8.33759C16.0623 8.156 15.9679 7.93093 15.6675 7.14988L13.9333 2.64102Z" fill="black" />
            </svg>
        }
    </div>;
}